module.exports = __webpack_public_path__ + "media/customizations/ryeranchlife/back-34edaeab3337afd6f9118e5e12cde0fc.jpg";